import * as React from "react";

import { Wrap } from "./styles";

import i18next from "i18next";
import { withTranslation, WithTranslation } from "react-i18next";

import { Utils } from "@zanichelli/myz-react-utils";
import Heading from "../../components/Heading";
import Content from "../../components/Content";
import ContentCheekToCheek from "../../components/ContentCheekToCheek";
import { S3_IMAGE_FOLDER } from "../../../constants/endpoint";
import RedirectButton from "../../components/RedirectButton";
import { GlobalState } from "../../store/rootReducer";
import { connect } from "react-redux";

type Props = {
  email?: string | null;
  myzTokenEmail?: string | null;
  logged: boolean;
} & WithTranslation;

type State = {};

class Error extends React.Component<Props, State> {
  public readonly state: State = {};

  renderLeftContent() {
    return (
      <div>
        <Heading title={i18next.t("newwotd.title")} />
        <Content>
          <div className="contentDescription">
            <p
              dangerouslySetInnerHTML={Utils.manageMarkupContent(
                i18next.t("newwotd.error.description"),
              )}
            />
            <p
              dangerouslySetInnerHTML={Utils.manageMarkupContent(
                i18next.t("newwotd.feedback.contact"),
              )}
            />
            <RedirectButton logged={this.props.logged} />
          </div>
        </Content>
      </div>
    );
  }

  render(): JSX.Element {
    return (
      <Wrap>
        <ContentCheekToCheek>
          {this.renderLeftContent()}
          <img src={S3_IMAGE_FOLDER + "/MyZanichelli_errore.png"} alt="" />
        </ContentCheekToCheek>
      </Wrap>
    );
  }
}

function mapStateToProps(state: GlobalState) {
  return {
    logged: !!state.myztokenuser.data?.userId,
  };
}
export default connect(mapStateToProps)(withTranslation()(Error));
